// DS: MO3.4.5
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import BuyButton from '@wix/da-ds/pkg/Buttons/BuyButton';
import DeviationShopCard from '../DeviationShopCard';
const SellPromotionCard = (_param)=>{
    var { deviation } = _param, rest = _object_without_properties(_param, [
        "deviation"
    ]);
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(DeviationShopCard, _object_spread({
        deviation: deviation,
        extraBiData: {
            sectionname: 'Start earning'
        },
        detailsRightSlot: /*#__PURE__*/ React.createElement(BuyButton, {
            size: "large",
            rounded: true,
            href: Url.deviationLink(deviation.deviationId)
        }, t('common.sell'))
    }, rest));
};
SellPromotionCard.displayName = 'SellPromotionCard';
export default SellPromotionCard;

//# sourceMappingURL=SellPromotionCard.js.map